// @mui
import { Box, Container, Typography, TextField, Button } from '@mui/material';

//
import PropTypes from 'prop-types';
import '../../styles/dashboard.scss';
import { useState, useEffect } from 'react';

// _mock
// hooks
// components
import { useSettingsContext } from 'src/components/settings';
import { GZAVNILI_MODES } from 'src/components/settings/drawer/gzavnili-mode';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
//
// import { EditNotifications } from '@mui/icons-material';
import { OrderBox } from 'src/assets/added_icons';
import ZebraPrintComponent from 'src/custom_components/Zebra/ZebraPrint';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import AlertReturnFunction from 'src/custom_components/Alert/AlertRetunrFunction';
import { useOrderActions, useOrderData } from 'src/context/providers/OrderContext';
import OrderDrawerComponent from '../order/order-drawer-component';
import { TIME_SLOT_FOR_ORDER } from '../order/view/data';

export default function TcTable({ TABLE_HEAD, defaultFilters, tableNames, kanbanInput }) {
  const [alertData, setAlertData] = useState(null);
  const [formData, setFormData] = useState({
    status: 'CHECKED',
    tracking: '',
  });
  const settings = useSettingsContext();
  const {
    updateOrderStatus,
    getOrderById,
    getOrdersForCheck,
    dispatchPhysicalOrder,
  } = useOrderActions();
  // eslint-disable-next-line
  const [date, setDate] = useState(new Date());

  // Custom
  const tableData = useOrderData().ordersCheck;
  const [aRow, setARow] = useState({});
  // Custom
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const slotType = settings.gzavniliMode === GZAVNILI_MODES.physical ? 'PHYSICAL' : 'ONLINE';
  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  // console.log(tableData[4].customer_address.address)

  const updateAcceptance = (e) => {
    e.preventDefault();
    const updateOrderData = {
      tracking: formData.tracking,
      status: 'CHECKED',
    };
    updateOrderStatus(updateOrderData).then(() => {
      setFormData({
        status: '',
        tracking: '',
      });
    });
  };

  const handlePhysicalCheck = async (e) => {
    e.preventDefault();
    const tracking = formData.tracking?.trim();
    if (!tracking) return;
    const dispatched = await dispatchPhysicalOrder(tracking).catch(() => null);
    if (dispatched) {
      getOrdersForCheck(slotType);
      setFormData({ status: '', tracking: '' });
    }
  };

  const clickedOrder = (e) => {
    const boxId = e.currentTarget.getAttribute('data-shelf-id');
    getOrderById(boxId).then((data) => {
      if (data) {
        setARow(data);
        setIsDrawerOpen(true);
      }
    });
  };

  const closeAlert = () => {
    setAlertData(null);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // const parseOrderDate = (orderDate) => {
  //   const formattedOrderDate = orderDate.replace(' at ', ' ').replace(' GMT+4', ' GMT+0400');
  //   return new Date(formattedOrderDate);
  // };

  useEffect(() => {
    getOrdersForCheck(slotType);
  }, [slotType, getOrdersForCheck]);

  return (
    <div>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        {alertData && (
          <AlertReturnFunction onClose={closeAlert} type={alertData.type} text={alertData.text} />
        )}
        {Object.keys(aRow)?.length > 0 && (
          <OrderDrawerComponent
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
            aRow={aRow}
            setARow={setARow}
          />
        )}

        <div
          style={{
            padding: '4px 0.5% 8px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <CustomBreadcrumbs heading="Check Order" sx={{ padding: 0 }} />
        </div>

        <div
          style={{
            padding: '4px 0.5% 12px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            width: '30%',
          }}
        >
          <form
            className="little_input_boxes"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
            onSubmit={(e) => (slotType === 'PHYSICAL' ? handlePhysicalCheck(e) : updateAcceptance(e))}
          >
            <TextField
              variant="filled"
              size="small"
              sx={{ minWidth: 200 }}
              name="tracking"
              label="Tracking"
              required
              value={formData.tracking}
              onChange={handleInputChange}
            />
            <Button variant="contained" type="submit">
              Check
            </Button>
          </form>
        </div>

        <Box>
          <div className="select_containers_large flex_evenly_column">
            <div
              className="child_kanban_check"
              style={
                settings.themeMode === 'light'
                  ? { backgroundColor: '#f4f6f8', padding: '10px' }
                  : { backgroundColor: '#2D353D', padding: '10px' }
              }
            >
              <CustomBreadcrumbs
                heading="To Check"
                sx={{ padding: '4px 0 10px', color: 'rgb(42, 167, 111)' }}
              />
              {TIME_SLOT_FOR_ORDER.filter((i) => i.label !== 'All').map((item, ind) => {
                const ordersForSlot = tableData?.['PICKED UP']?.[item.value];
                if (!ordersForSlot) return null;

                // Group orders by room_number
                const groupedByRoom = ordersForSlot.reduce((acc, order) => {
                  if (!acc[order.room_number]) acc[order.room_number] = [];
                  acc[order.room_number].push(order);
                  return acc;
                }, {});

                return (
                  <div
                    key={ind}
                    style={
                      settings.themeMode === 'light'
                        ? { backgroundColor: '#f4f6f8', padding: '5px', width: '100%' }
                        : { backgroundColor: '#2D353D', padding: '5px', width: '100%' }
                    }
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        margin: '10px 0px',
                      }}
                    >
                      <AccessAlarmIcon style={{ color: '#2aa76f' }} />
                      <Typography variant="h6" style={{ color: '#2aa76f', fontSize: '15px' }}>
                        {item.label}
                      </Typography>
                    </Box>

                    {Object.entries(groupedByRoom).map(([roomNumber, orders]) =>
                      orders.map((i) => (
                        <Box
                          className="box_items_check"
                          key={i.id}
                          data-shelf-id={i.id}
                          onClick={clickedOrder}
                          style={
                            settings.themeMode === 'light'
                              ? { backgroundColor: '#ffffff' }
                              : { backgroundColor: '#161C24' }
                          }
                        >
                          <img src={OrderBox} width="40px" height="40px" alt="" id={i.id} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="bold_heading">{i.tracking_number}</div>
                            <div className="light_text">{i?.customer_address?.address}</div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="bold_heading">{i.room_number}</div>
                            <div className="light_text">{i.status}</div>
                          </div>
                        </Box>
                      ))
                    )}
                  </div>
                );
              })}
            </div>
            <div
              className="child_kanban_check"
              style={
                settings.themeMode === 'light'
                  ? { backgroundColor: '#f4f6f8', padding: '10px' }
                  : { backgroundColor: '#2D353D', padding: '10px' }
              }
            >
              <CustomBreadcrumbs
                heading={slotType === 'ONLINE' ? 'Checked' : 'Out for delivery'}
                sx={{ padding: '4px 0 10px', color: 'rgb(42, 167, 111)' }}
              />
              {TIME_SLOT_FOR_ORDER?.filter((item) => item.label !== 'All')?.map((timeSlot, ind) => {
                const orders = tableData?.CHECKED?.[timeSlot.value];
                if (!orders) return null;

                // Group by room_number
                const groupedByRoom = orders.reduce((acc, order) => {
                  if (!acc[order.room_number]) acc[order.room_number] = [];
                  acc[order.room_number].push(order);
                  return acc;
                }, {});

                return (
                  <div
                    key={ind}
                    style={
                      settings.themeMode === 'light'
                        ? { backgroundColor: '#f4f6f8', padding: '5px' }
                        : { backgroundColor: '#2D353D', padding: '5px' }
                    }
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        margin: '10px 0px',
                      }}
                    >
                      <AccessAlarmIcon style={{ color: '#2aa76f' }} />
                      <Typography variant="h6" style={{ color: '#2aa76f', fontSize: '15px' }}>
                        {timeSlot.label}
                      </Typography>
                    </Box>

                    {Object.entries(groupedByRoom).map(([roomNumber, roomOrders]) =>
                      roomOrders.map((i) => (
                        <Box
                          className="box_items_check"
                          key={i.id}
                          data-shelf-id={i.id}
                          style={
                            settings.themeMode === 'light'
                              ? { backgroundColor: '#ffffff' }
                              : { backgroundColor: '#161C24' }
                          }
                        >
                          <img src={OrderBox} width="40px" height="40px" alt="" id={i.id} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="bold_heading">{i.tracking_number}</div>
                            <div className="light_text">{i?.customer_address?.address}</div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="bold_heading">{i.room_number}</div>
                            <div className="light_text">{i.status}</div>
                          </div>
                          {slotType === 'ONLINE' && (
                            <div style={{ marginLeft: 'auto' }}>
                              <ZebraPrintComponent i={i} />
                            </div>
                          )}
                        </Box>
                      ))
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Box>
      </Container>

      {slotType === 'ONLINE' && (
        <Box
          style={
            settings.themeMode === 'light'
              ? {
                  backgroundColor: '#f4f5f8',
                  minHeight: '300px',
                  width: '40%',
                  paddingBottom: '20px',
                  border: '1px solid rgba(255, 255, 255)',
                  borderRadius: '20px',
                  color: 'rgb(42, 167, 111)',
                  margin: '20px',
                }
              : {
                  backgroundColor: '#2d353d',
                  minHeight: '300px',
                  width: '40%',
                  paddingBottom: '20px',
                  border: '1px solid rgba(255, 255, 255)',
                  borderRadius: '20px',
                  color: 'rgb(42, 167, 111)',
                  margin: '20px',
                }
          }
        >
          <CustomBreadcrumbs heading="ONWAY Orders" sx={{ padding: '10px' }} />
          {(() => {
            const groupedByRoom = tableData?.onWay?.reduce((acc, order) => {
              if (!acc[order.room_number]) acc[order.room_number] = [];
              acc[order.room_number].push(order);
              return acc;
            }, {});

            return Object.entries(groupedByRoom || {}).map(([roomNumber, orders]) =>
              orders.map((i) => (
                <Box
                  className="box_items_slot"
                  key={i.id}
                  data-shelf-id={i.id}
                  onClick={clickedOrder}
                  style={
                    settings.themeMode === 'light'
                      ? { backgroundColor: '#ffffff', alignItems: 'center' }
                      : { backgroundColor: '#161C24', alignItems: 'center' }
                  }
                  sx={{ width: '90%', margin: '10px' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: '5px',
                      }}
                    >
                      <div className="light_text" style={{ fontSize: '0.8rem' }}>
                        {i.tracking_number}
                      </div>
                      -
                      <div className="light_text" style={{ fontSize: '0.8rem' }}>
                        {i?.shelf?.code}
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '5px',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <div className="light_text" style={{ fontSize: '0.8rem' }}>
                        {i?.customer_address?.address}
                      </div>
                      -
                      <div className="light_text" style={{ fontSize: '0.8rem' }}>
                        {i?.customer?.first_name_ka} {i?.customer?.last_name_ka}
                      </div>
                    </div>
                  </div>
                </Box>
              ))
            );
          })()}
        </Box>
      )}
    </div>
  );
}

TcTable.propTypes = {
  TABLE_HEAD: PropTypes.array,
  defaultFilters: PropTypes.object,
  tableNames: PropTypes.array,
  kanbanInput: PropTypes.array,
};
